export const ROUTES_WITHOUT_NAV = ['/orders/create', '/orders/:orderId'];

export const ORDER_SLUGS_WITH_NAV = ['csv-import', 'batch'];
